import { render, staticRenderFns } from "./review-stars.vue?vue&type=template&id=756e3530"
import script from "./review-stars.vue?vue&type=script&lang=js"
export * from "./review-stars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports